<mat-card>
  <h2>
    {{ (!interviniente ? 'contactData.title' : 'intervinentContactData.title') | translate }} {{ numInterviniente }}
  </h2>

  <div>
    <div fxFlex fxLayout="row wrap" *ngIf="interviniente">
      <div fxFlex="100">
        <mat-checkbox
          class="checkbox__formfield"
          [disabled]="mode === 'view' || !isCheckContactDataEnabled"
          (change)="copyFromHolder($event)"
        >
          <mat-label translate>intervinentContactData.copy</mat-label>
        </mat-checkbox>
      </div>
    </div>
  </div>

  <form [formGroup]="contactDataForm">
    <div fxFlex fxLayout="row wrap" class="form-wrapper">
      <!-- ROW -->
      <div fxFlex="100" fxFlex.gt-sm="50">
        <mat-form-field fxFlex="100" appearance="outline">
          <mat-label translate>contactData.address</mat-label>
          <input
            [id]="'addressContactData' + (interviniente ? numInterviniente : '')"
            formControlName="address"
            matInput
            type="text"
            maxlength="50"
            autocomplete="off"
          />
          <mat-error *ngIf="contactDataForm.controls.address.hasError('required')" translate>
            field.required
          </mat-error>
        </mat-form-field>
      </div>
      <div fxFlex="30" fxFlex.gt-sm="20">
        <mat-form-field fxFlex="100" appearance="outline">
          <mat-label translate>contactData.number</mat-label>
          <input
            #number
            [id]="'numberContactData' + (interviniente ? numInterviniente : '')"
            formControlName="number"
            matInput
            type="text"
            maxlength="5"
            (keypress)="numberOnly($event, number)"
            (blur)="noSpaces($event, number)"
            autocomplete="off"
          />
          <mat-error *ngIf="contactDataForm.controls.number.hasError('required')" translate> field.required </mat-error>
          <mat-error
            *ngIf="contactDataForm.controls.number.invalid && !contactDataForm.controls.number.hasError('required')"
            translate
          >
            field.error.number
          </mat-error>
        </mat-form-field>
      </div>
      <div fxFlex="70" fxFlex.gt-sm="30">
        <mat-form-field fxFlex="100" appearance="outline">
          <mat-label translate>contactData.adressComplement</mat-label>
          <input
            [id]="'addressComplementContactData' + (interviniente ? numInterviniente : '')"
            formControlName="addressComplement"
            matInput
            type="text"
            maxlength="15"
            autocomplete="off"
          />
          <mat-hint translate>request.optional</mat-hint>
        </mat-form-field>
      </div>

      <!-- ROW -->
      <div fxFlex="30" fxFlex.gt-sm="15">
        <mat-form-field fxFlex="100" appearance="outline">
          <mat-label translate>contactData.floor</mat-label>
          <input
            [id]="'floorContactData' + (interviniente ? numInterviniente : '')"
            formControlName="floor"
            matInput
            type="text"
            maxlength="2"
            autocomplete="off"
          />
          <mat-hint translate>request.optional</mat-hint>
          <mat-error
            *ngIf="contactDataForm.controls.floor.invalid && !contactDataForm.controls.floor.hasError('required')"
            translate
          >
            field.error.floor
          </mat-error>
        </mat-form-field>
      </div>
      <div fxFlex="30" fxFlex.gt-sm="15">
        <mat-form-field fxFlex="100" appearance="outline">
          <mat-label translate>contactData.door</mat-label>
          <input
            #door
            [id]="'doorContactData' + (interviniente ? numInterviniente : '')"
            formControlName="door"
            matInput
            type="text"
            maxlength="1"
            (keypress)="alphanumericOnly($event, door)"
            autocomplete="off"
          />
          <mat-hint translate>request.optional</mat-hint>
          <mat-error *ngIf="contactDataForm.controls.door.errors?.alphanumericInvalid" translate>
            field.error.alphanumeric
          </mat-error>
        </mat-form-field>
      </div>
      <div fxFlex="40" fxFlex.gt-sm="30">
        <mat-form-field fxFlex="100" appearance="outline">
          <mat-label translate>contactData.postalCode</mat-label>
          <input
            #postalCode
            [id]="'postalCodeContactData' + (interviniente ? numInterviniente : '')"
            formControlName="postalCode"
            matInput
            (keypress)="numberOnly($event, postalCode)"
            (change)="updateTown($event)"
            type="text"
            maxlength="5"
            autocomplete="off"
          />
          <mat-error *ngIf="contactDataForm.controls.postalCode.hasError('required')" translate>
            field.required
          </mat-error>
          <mat-error
            *ngIf="
              contactDataForm.controls.postalCode.invalid && !contactDataForm.controls.postalCode.hasError('required')
            "
            translate
          >
            field.error.postalCode
          </mat-error>
        </mat-form-field>
      </div>
      <div fxFlex="100" fxFlex.gt-sm="40">
        <mat-form-field fxFlex="100" appearance="outline">
          <mat-label translate>contactData.town</mat-label>
          <input
            #town
            [id]="'town' + (interviniente ? numInterviniente : '')"
            formControlName="town"
            matInput
            type="text"
            autocomplete="off"
          />
          <mat-error *ngIf="contactDataForm.controls.town.hasError('required')" translate> field.required </mat-error>
        </mat-form-field>
      </div>

      <!-- ROW -->
      <div fxFlex="50" fxFlex.gt-sm="25">
        <mat-form-field fxFlex="100" appearance="outline">
          <mat-label translate>contactData.phone</mat-label>
          <input
            #phone
            [id]="'phoneContactData' + (interviniente ? numInterviniente : '')"
            formControlName="phone"
            matInput
            type="text"
            maxlength="9"
            (keypress)="alphanumericHyphenBackslash($event, phone)"
            (blur)="onMobilePhoneBlur($event, phone)"
            autocomplete="off"
          />
          <mat-error *ngIf="contactDataForm.controls.phone.hasError('required')" translate> field.required </mat-error>
          <mat-error
            *ngIf="contactDataForm.controls.phone.invalid && !contactDataForm.controls.phone.hasError('required')"
            translate
          >
            field.error.telefono
          </mat-error>
        </mat-form-field>
      </div>

      <div fxFlex="50" fxFlex.gt-sm="25">
        <mat-form-field fxFlex="100" appearance="outline">
          <mat-label translate>contactData.additionalPhone</mat-label>
          <input
            #additionalPhone
            [id]="'additionalPhoneContactData' + (interviniente ? numInterviniente : '')"
            formControlName="additionalPhone"
            matInput
            type="text"
            maxlength="9"
            (keypress)="alphanumericHyphenBackslash($event, additionalPhone)"
            (blur)="alphanumericAndSpecialCharacters($event, additionalPhone)"
            autocomplete="off"
          />
          <mat-hint *ngIf="!contactDataForm.controls.nophone.value" translate>request.optional</mat-hint>
          <mat-error *ngIf="contactDataForm.controls.additionalPhone.hasError('required')" translate>
            field.required
          </mat-error>
          <mat-error
            *ngIf="
              contactDataForm.controls.additionalPhone.invalid &&
              !contactDataForm.controls.additionalPhone.hasError('required') &&
              !contactDataForm.controls.additionalPhone.errors?.islandlineValid
            "
            translate
          >
            field.error.telefono.adicional
          </mat-error>
          <mat-error *ngIf="contactDataForm.controls.additionalPhone.errors?.islandlineValid" translate>
            field.error.telefono.adicional2
          </mat-error>
        </mat-form-field>
      </div>
      <div
        fxFlex="{{ isAuto || isConsumption ? '70' : '100' }}"
        fxFlex.gt-sm="{{ isAuto || isConsumption ? '35' : '50' }}"
      >
        <mat-form-field fxFlex="100" appearance="outline">
          <mat-label translate>contactData.email</mat-label>
          <input
            [id]="'emailContactData' + (interviniente ? numInterviniente : '')"
            formControlName="email"
            matInput
            type="text"
            maxlength="60"
            autocomplete="off"
          />
          <mat-error *ngIf="contactDataForm.controls.email.hasError('required')" translate> field.required </mat-error>
          <mat-error
            *ngIf="contactDataForm.controls.email.invalid && !contactDataForm.controls.email.hasError('required')"
            translate
          >
            field.error.email
          </mat-error>
        </mat-form-field>
      </div>

      <div fxFlex="30" fxFlex.gt-sm="15" *ngIf="isAuto || isConsumption">
        <div class="noemail__checkbox">
          <input
            color="accent"
            type="checkbox"
            [id]="'checkNoEmail' + (interviniente ? numInterviniente : '')"
            name="checkNoEmail"
            formControlName="noemail"
            (change)="noemailChange()"
            autocomplete="off"
          />
          <span translate>contactData.noemail</span>
        </div>
        <div class="noemail__checkbox">
          <input
            color="accent"
            type="checkbox"
            [id]="'checkNoPhone' + (interviniente ? numInterviniente : '')"
            name="checkNoPhone"
            formControlName="nophone"
            (change)="noPhoneChange()"
            autocomplete="off"
          />
          <span translate>contactData.nophone</span>
        </div>
      </div>
    </div>
  </form>
</mat-card>

<!-- CTI CODIGO COMENTADO-->
<!-- <mat-card>
  <h2>
    {{ (!interviniente ? 'contactData.title' : 'intervinentContactData.title') | translate }} {{ numInterviniente }}
  </h2>

  <div>
    <div fxFlex fxLayout="row wrap" *ngIf="interviniente">
      <div fxFlex="100">
        <mat-checkbox
          class="checkbox__formfield"
          [disabled]="mode === 'view' || !isCheckContactDataEnabled"
          (change)="copyFromHolder($event)"
        >
          <mat-label translate>intervinentContactData.copy</mat-label>
        </mat-checkbox>
      </div>
    </div>
  </div>

  <form [formGroup]="contactDataForm">
    <div fxFlex fxLayout="row wrap" class="form-wrapper">
      <div fxFlex="100" fxFlex.gt-sm="40">
        <mat-form-field fxFlex="100" appearance="outline">
          <mat-label translate>contactData.postalCode</mat-label>
          <input
            #postalCode
            id="postalCodeContactData"
            formControlName="postalCode"
            matInput
            (keypress)="numberOnly($event, postalCode)"
            type="text"
            maxlength="5"
            autocomplete="off"
            (blur)="validateNormalizacion()"
          />
          <mat-hint *ngIf="optionalCodPostal" translate>request.optional</mat-hint>
          <mat-error *ngIf="contactDataForm.controls.postalCode.hasError('required')" translate>
            field.required
          </mat-error>
          <mat-error
            *ngIf="
              contactDataForm.controls.postalCode.invalid && !contactDataForm.controls.postalCode.hasError('required')
            "
            translate
          >
            field.error.postalCode
          </mat-error>
        </mat-form-field>
      </div>

      <div *ngIf="!showTrackType" fxFlex="100" fxFlex.gt-sm="60">
        <mat-form-field fxFlex="100" appearance="outline">
          <mat-label translate>contactData.town</mat-label>
          <input id="town" formControlName="town" matInput type="text" autocomplete="off" />
          <mat-error *ngIf="contactDataForm.controls.town.hasError('required')" translate> field.required </mat-error>
        </mat-form-field>
      </div>

      <div *ngIf="showTrackType" fxFlex="100" fxFlex.gt-sm="60">
        <scf-custom-select-search
          fxFlex="100"
          formControlName="town"
          [id]="'town'"
          [dataInput]="listPopulation"
          [isCTI]="true"
          [placeholder]="'contactData.town'"
          [isRequired]="true"
          [showErrors]="contactDataForm?.controls?.town?.errors"
          (searchChange)="loadListPopulation($event)"
          (onSelectCheckAll)="updatePoblationSelected($event)"
          (selectionChange)="validateNormalizacion('town')"
        ></scf-custom-select-search>
      </div>

      <div *ngIf="showTrackType" fxFlex="100" fxFlex.gt-sm="20">
        <scf-custom-select-search
          fxFlex="100"
          formControlName="trackType"
          [id]="'trackType'"
          [dataInput]="listTypesVia"
          [placeholder]="'Tipo vía'"
          [isRequired]="true"
          [showErrors]="contactDataForm?.controls?.tracktype?.errors"
          (selectionChange)="validateNormalizacion()"
        ></scf-custom-select-search>
      </div>

      <div *ngIf="!showTrackType" fxFlex="100" fxFlex.gt-sm="40">
        <mat-form-field fxFlex="100" appearance="outline">
          <mat-label translate>contactData.address</mat-label>
          <input id="addressContactData" formControlName="address" matInput type="text" autocomplete="off" />
          <mat-error *ngIf="contactDataForm.controls.address.hasError('required')" translate>
            field.required
          </mat-error>
        </mat-form-field>
      </div>

      <div *ngIf="showTrackType" fxFlex="100" fxFlex.gt-sm="50">
        <scf-custom-select-search
          fxFlex="100"
          formControlName="address"
          [id]="'addressContactData'"
          [dataInput]="listVia"
          [isCTI]="true"
          [placeholder]="'contactData.address'"
          [isRequired]="true"
          [showErrors]="contactDataForm?.controls?.address?.errors"
          (searchChange)="loadListVia($event)"
          (selectionChange)="validateNormalizacion('address')"
        ></scf-custom-select-search>
      </div>

      <div fxFlex="30" fxFlex.gt-sm="10">
        <mat-form-field fxFlex="100" appearance="outline">
          <mat-label translate>contactData.number</mat-label>
          <input
            #number
            id="numberContactData"
            formControlName="number"
            matInput
            type="text"
            maxlength="5"
            (keypress)="numberOnly($event, number)"
            (blur)="checkNormalizarVia()"
            autocomplete="off"
          />
          <mat-error *ngIf="contactDataForm.controls.number.hasError('required')" translate> field.required </mat-error>
          <mat-error
            *ngIf="
              contactDataForm.controls.number.invalid &&
              !contactDataForm.controls.number.hasError('required') &&
              !errorNormalizarDomicilio
            "
            translate
          >
            field.error.number
          </mat-error>
        </mat-form-field>
      </div>
      <div fxFlex="70" fxFlex.gt-sm="20">
        <mat-form-field fxFlex="100" appearance="outline">
          <mat-label translate>contactData.adressComplement</mat-label>
          <input
            id="addressComplementContactData"
            formControlName="addressComplement"
            matInput
            type="text"
            maxlength="15"
            autocomplete="off"
          />
          <mat-hint translate>request.optional</mat-hint>
        </mat-form-field>
      </div>
      <div fxFlex="30" fxFlex.gt-sm="{{ showTrackType ? 15 : 10 }}">
        <mat-form-field fxFlex="100" appearance="outline">
          <mat-label translate>contactData.floor</mat-label>
          <input id="floorContactData" formControlName="floor" matInput type="text" maxlength="2" autocomplete="off" />
          <mat-hint translate>request.optional</mat-hint>
          <mat-error
            *ngIf="contactDataForm.controls.floor.invalid && !contactDataForm.controls.floor.hasError('required')"
            translate
          >
            field.error.floor
          </mat-error>
        </mat-form-field>
      </div>
      <div fxFlex="30" fxFlex.gt-sm="15">
        <mat-form-field fxFlex="100" appearance="outline">
          <mat-label translate>contactData.door</mat-label>
          <input
            #door
            id="doorContactData"
            formControlName="door"
            matInput
            type="text"
            maxlength="1"
            (keypress)="alphanumericOnly($event, door)"
            autocomplete="off"
          />
          <mat-hint translate>request.optional</mat-hint>
          <mat-error *ngIf="contactDataForm.controls.door.errors?.alphanumericInvalid" translate>
            field.error.alphanumeric
          </mat-error>
        </mat-form-field>
      </div>
      <div fxFlex="50" fxFlex.gt-sm="25">
        <mat-form-field fxFlex="100" appearance="outline">
          <mat-label translate>contactData.phone</mat-label>
          <input
            #phone
            id="phoneContactData"
            formControlName="phone"
            matInput
            type="text"
            maxlength="9"
            (keypress)="alphanumericHyphenBackslash($event, phone)"
            (blur)="onMobilePhoneBlur($event, phone)"
            autocomplete="off"
          />
          <mat-error *ngIf="contactDataForm.controls.phone.hasError('required')" translate> field.required </mat-error>
          <mat-error
            *ngIf="contactDataForm.controls.phone.invalid && !contactDataForm.controls.phone.hasError('required')"
            translate
          >
            field.error.telefono
          </mat-error>
        </mat-form-field>
      </div>

      <div fxFlex="50" fxFlex.gt-sm="25">
        <mat-form-field fxFlex="100" appearance="outline">
          <mat-label translate>contactData.additionalPhone</mat-label>
          <input
            #additionalPhone
            id="additionalPhoneContactData"
            formControlName="additionalPhone"
            matInput
            type="text"
            maxlength="9"
            (keypress)="alphanumericHyphenBackslash($event, additionalPhone)"
            (blur)="alphanumericAndSpecialCharacters($event, additionalPhone)"
            autocomplete="off"
          />
          <mat-hint *ngIf="!contactDataForm.controls.nophone.value" translate>request.optional</mat-hint>
          <mat-error *ngIf="contactDataForm.controls.additionalPhone.hasError('required')" translate>
            field.required
          </mat-error>
          <mat-error
            *ngIf="
              contactDataForm.controls.additionalPhone.invalid &&
              !contactDataForm.controls.additionalPhone.hasError('required') &&
              !contactDataForm.controls.additionalPhone.errors?.islandlineValid
            "
            translate
          >
            field.error.telefono.adicional
          </mat-error>
          <mat-error *ngIf="contactDataForm.controls.additionalPhone.errors?.islandlineValid" translate>
            field.error.telefono.adicional2
          </mat-error>
        </mat-form-field>
      </div>
      <div
        fxFlex="{{ isAuto || isConsumption ? '70' : '100' }}"
        fxFlex.gt-sm="{{ isAuto || isConsumption ? '35' : '50' }}"
      >
        <mat-form-field fxFlex="100" appearance="outline">
          <mat-label translate>contactData.email</mat-label>
          <input id="emailContactData" formControlName="email" matInput type="text" maxlength="60" autocomplete="off" />
          (blur)="checkValidarEmail($event.target)" deshabilitado porque no esta el servicio en la API
          <mat-error *ngIf="contactDataForm.controls.email.hasError('required')" translate> field.required </mat-error>
          <mat-error
            *ngIf="contactDataForm.controls.email.invalid && !contactDataForm.controls.email.hasError('required')"
            translate
          >
            field.error.email
          </mat-error>
        </mat-form-field>
      </div>
      <div fxFlex="30" fxFlex.gt-sm="15" *ngIf="isAuto || isConsumption">
        <div class="noemail__checkbox">
          <input
            color="accent"
            type="checkbox"
            id="checkNoEmail"
            name="checkNoEmail"
            formControlName="noemail"
            (change)="noemailChange()"
            autocomplete="off"
          />
          <span translate>contactData.noemail</span>
        </div>
        <div class="noemail__checkbox">
          <input
            color="accent"
            type="checkbox"
            id="checkNoPhone"
            name="checkNoPhone"
            formControlName="nophone"
            (change)="noPhoneChange()"
            autocomplete="off"
          />
          <span translate>contactData.nophone</span>
        </div>
      </div>
    </div>
  </form>
</mat-card> -->
